/**
 * Header: mega menu, selettore lingua, ricerca.
 * Era inline nella section (8 KB di JS su ogni pagina): spostato qui per
 * togliere il parse dal documento e renderlo cacheabile tra le pagine.
 */
const navButtons = document.querySelectorAll('.nav-button');
let isMenuTransitioning = false; // Use this to prevent rapid clicks causing issues

// Function to remove active class from all nav buttons
function deactivateNavButtons() {
  navButtons.forEach((btn) => btn.classList.remove('is-active'));
}

// Function to handle menu closing immediately
function closeMenu(menu, callback) {
  if (!menu) {
    if (callback) callback();
    return;
  }
  const correspondingButton = document.querySelector(`[data-target="${menu.id}"]`);
  if (correspondingButton) {
    correspondingButton.classList.remove('is-active');
  }
  menu.classList.remove('active');
  menu.classList.remove('no-animation'); // Clean up class on close
  menu.classList.remove('closing'); // Clean up class on close
  if (callback) {
    // Execute callback almost immediately, allowing DOM to update
    requestAnimationFrame(callback);
  }
}

if (navButtons) {
  navButtons.forEach((button) =>
    button.addEventListener('click', (event) => {
      if (isMenuTransitioning) return; // Prevent action if already transitioning

      const clickedButton = event.currentTarget;
      const target = clickedButton.dataset.target;
      const currentMenu = document.getElementById(target);
      const activeMenu = document.querySelector('.megamenu.active');

      if (currentMenu && currentMenu === activeMenu) {
        // Clicked the button for the menu that is already open - close it.
        isMenuTransitioning = true;
        closeMenu(activeMenu, () => {
          isMenuTransitioning = false;
        });
        // No return here, let it fall through to potentially re-open if needed,
        // but closeMenu already removed the active class from the button.
        // Actually, let's return to prevent re-opening immediately.
        return;
      }

      isMenuTransitioning = true; // Start transition lock

      // Function to open the target menu and activate its button
      const openCurrentMenu = (menuToOpen, buttonToActivate, animate) => {
        if (menuToOpen) {
          // Deactivate all other buttons first
          deactivateNavButtons();
          // Activate the current button
          if (buttonToActivate) {
            buttonToActivate.classList.add('is-active');
          }

          if (animate) {
            menuToOpen.classList.remove('no-animation'); // Ensure animation runs
            menuToOpen.classList.add('active');
            // Unlock after animation duration
            setTimeout(() => {
              isMenuTransitioning = false;
            }, 350); // Match animation time
          } else {
            menuToOpen.classList.add('no-animation'); // Prevent animation
            menuToOpen.classList.add('active');
            // Unlock almost immediately for no-animation case
            requestAnimationFrame(() => {
              isMenuTransitioning = false;
            });
          }
        } else {
          // No current menu to open, just unlock and ensure no buttons are active
          deactivateNavButtons();
          isMenuTransitioning = false;
        }
      };

      if (activeMenu) {
        // Switching menus: Close old instantly, open new instantly (no animation)
        // closeMenu handles removing the active class from the old button
        closeMenu(activeMenu, () => {
          openCurrentMenu(currentMenu, clickedButton, false); // Open new one without animation
        });
      } else if (currentMenu) {
        // Opening a menu when none are active: Open with animation
        openCurrentMenu(currentMenu, clickedButton, true);
      } else {
        // No active menu and no current menu (e.g., button without target?)
        deactivateNavButtons(); // Ensure no buttons are active
        isMenuTransitioning = false; // Unlock
      }
    })
  );
}

// Click outside logic
document.addEventListener('click', (event) => {
  // Check if already transitioning or if click is inside relevant areas
  if (isMenuTransitioning || event.target.closest('.megamenu') || event.target.closest('.nav-button')) {
    return;
  }

  const activeMenus = document.querySelectorAll('.megamenu.active');
  if (activeMenus.length > 0) {
    isMenuTransitioning = true; // Lock during closing
    let closedCount = 0;
    activeMenus.forEach((menu) => {
      // closeMenu will handle removing the active class from the corresponding button
      closeMenu(menu, () => {
        closedCount++;
        if (closedCount === activeMenus.length) {
          isMenuTransitioning = false; // Unlock after all are closed
        }
      });
    });
  }
});

// Language Dropdown Logic (remains the same)
document.addEventListener('DOMContentLoaded', () => {
  const langWrapper = document.querySelector('.language-dropdown');
  const langToggle = langWrapper?.querySelector('.dropdown-toggle');

  if (langToggle && langWrapper) {
    langToggle.addEventListener('click', (e) => {
      e.preventDefault();
      // Prevent click outside logic from closing immediately
      e.stopPropagation();
      langWrapper.classList.toggle('open');
    });

    // Close language dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!langWrapper.contains(e.target)) {
        langWrapper.classList.remove('open');
      }
    });
  }
});

// Localization Form Submit Logic (remains the same)
document.addEventListener('DOMContentLoaded', () => {
  // Gestione cambio lingua
  document.querySelectorAll('[name="locale_code"]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const form = btn.closest('form');
      if (form) form.submit();
    });
  });

  // Gestione cambio paese
  document.querySelectorAll('[name="country_code"]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const form = btn.closest('form');
      if (form) form.submit();
    });
  });
});

// search

document.addEventListener('DOMContentLoaded', () => {
  const searchModal = document.querySelector('.header__search');
  const toggleDesktopSearchBtn = document.getElementById('search-button-desktop');
  const toggleMobileSearchBtn = document.getElementById('search-button-mobile');
  const mobileSearchWrapper = document.getElementById('search-wrapper');
  const closeSearchBtn = document.getElementById('close-search-button');

  function isSearchOpen() {
    return document.body.classList.contains('search-open');
  }

  function openSearch() {
    document.body.classList.add('search-open');
    if (searchModal) searchModal.setAttribute('open', '');
    if (mobileSearchWrapper) mobileSearchWrapper.style.display = 'block';
    // Focus the search input
    const searchInput = mobileSearchWrapper?.querySelector('input[type="search"]');
    searchInput?.focus();
  }

  function closeSearch() {
    document.body.classList.remove('search-open');
    if (searchModal) searchModal.removeAttribute('open');
    if (mobileSearchWrapper) mobileSearchWrapper.style.display = 'none';
  }

  toggleDesktopSearchBtn?.addEventListener('click', () => {
    isSearchOpen() ? closeSearch() : openSearch();
  });

  toggleMobileSearchBtn?.addEventListener('click', () => {
    isSearchOpen() ? closeSearch() : openSearch();
  });

  closeSearchBtn?.addEventListener('click', () => {
    closeSearch();
  });

  document.addEventListener('click', (e) => {
    const isInsideSearch =
      e.target.closest('#search-wrapper') ||
      e.target.closest('#search-button-desktop') ||
      e.target.closest('#search-button-mobile');

    if (!isInsideSearch && isSearchOpen()) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isSearchOpen()) {
      closeSearch();
    }
  });
});
